import { businessToday } from '@/features/dashboard/utils'

export function getDefaultStockReportAsOf(): string {
  return businessToday()
}
